// extracted by mini-css-extract-plugin
export default {"formRow":"formRow__wlFB9","label":"label__zsQbG","textInput":"textInput__vSBAd","form":"form__K9AMM","infoText":"infoText__c2qxL","p2":"p2__N2wiP"};